import script from "./CContact.vue?vue&type=script&setup=true&lang=ts"
export * from "./CContact.vue?vue&type=script&setup=true&lang=ts"

import "./CContact.vue?vue&type=style&index=0&id=c0d1bf36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d1bf36"]])

export default __exports__